<template>
  <page class="referrals-page">
    <referral-poster></referral-poster>
    <referral-controls></referral-controls>
    <content-container class="container">
      <referral-steps></referral-steps>
      <referral-description></referral-description>
    </content-container>
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import ContentContainer from '@/components/common/ContentContainer.vue';
import ReferralSteps from '@/components/referral/ReferralSteps.vue';
import ReferralPoster from '@/components/referral/ReferralPoster.vue';
import ReferralDescription from '@/components/referral/ReferralDescription.vue';
import ReferralControls from '@/components/referral/ReferralControls.vue';

export default {
  components: {
    Page,
    ContentContainer,
    ReferralPoster,
    ReferralSteps,
    ReferralDescription,
    ReferralControls,
  },
};
</script>

<style lang="scss" scoped>
.referrals-page {
  display: flex;
  flex: 1;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0px;
}
</style>
